export default __webpack_public_path__ + "static/media/megaphone.2a526eec.svg";